import React, { PropTypes } from 'react';
import { Field, reduxForm, formValueSelector, FieldArray, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import alert from 'alertify.js';
import axios from './../../../constants/axios';
import SelectAsync from './../../FormTemplate/SelectAsync';
import Select from './../../FormTemplate/Select';
import TextareaControl from './../../FormTemplate/TextareaControl';
import FormExpenseList from './FormHelper/FormExpenseList';
import selectOptionFormatter from './../../../selectors/selectOptionFormatter';

class NewExpenseForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         vendorAddresses: [],
         expenseAccounts: []
      };
   }

   componentDidMount() {
      axios.get('expenses/getExpenseAccounts')
         .then(res => {
            this.setState({
               expenseAccounts: selectOptionFormatter(res.data)
            });
         });
   }

   componentWillReceiveProps(nextProps) {
      if (nextProps.contact_id && (typeof nextProps.contact_id === 'number') && nextProps.contact_id !== this.props.contact_id) {
         axios.get(`contacts/${nextProps.contact_id}/getAddresses`)
            .then((res) => {
               let n = res.data.map((add) => {
                  return {
                     value: add.id,
                     label: `${add.address} | ${add.contact_address_type_name}`
                  };
               });
               this.setState({
                  vendorAddresses: n
               });
            });
      }

      if (nextProps.items && nextProps.items.length > 0) {
         nextProps.items.forEach((item) => {
            if (item.price && item.unit) {
               item.total = item.price * item.unit;
            } else {
               item.total = '';
            }
         });
      }
   }


   submit = (values) => {
      const dataToSend = {
         contact_id: values.contact_id,
         contact_address_id: values.contact_address_id,
         items: values.items
      };
      if (values.memo) {
         dataToSend.memo = values.memo;
      }
      return axios.post('/expenses', dataToSend)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Expense invoice created.');
               this.context.router.push('/expense');
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };


   render() {
      const { handleSubmit, submitting, pristine, invalid, error } = this.props;
      const { vendorAddresses, expenseAccounts } = this.state;
      return (
         <form noValidate="true" autoComplete="off" onSubmit={handleSubmit(this.submit)} >
            <div className="row" >
               <div className="col-md-6" >
                  <Field name="contact_id" minimumInput={1} component={SelectAsync} link="contacts/vendors/searchByName"
                         label="Vendor Name" />
               </div>
               <div className="col-md-6" >
                  <Field name="contact_address_id" allowEmpty={true} component={Select} options={vendorAddresses}
                         label="Vendor Address" />
               </div>
            </div>

            <FieldArray name="items" component={FormExpenseList} expenseAccounts={expenseAccounts} />

            <Field name="memo" label="Memo" component={TextareaControl} />
            {error && <strong className="input-validation-error" >{error}</strong>}
            <Button type="submit" bsStyle="success" block
                    disabled={submitting || pristine || invalid} >Save</Button>
         </form>
      );
   }
}
NewExpenseForm.propTypes = {
   handleSubmit: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
   ]),
   contact_id: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.number
   ])
};

NewExpenseForm.contextTypes = {
   router: PropTypes.object
};

NewExpenseForm = reduxForm({ // eslint-disable-line
   form: 'newExpenseForm'
})(NewExpenseForm);

const selector = formValueSelector('newExpenseForm');

NewExpenseForm = connect(state => { // eslint-disable-line
   const contact_id = selector(state, 'contact_id');
   return {
      contact_id
   };
})(NewExpenseForm);

export default NewExpenseForm;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Expense/NewExpenseForm.js
 **/